import { DataSource, HorizontalSpacer, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutProspectAction extends Layout {
    horizontalspacer1: HorizontalSpacer;
    sourceProspectAction: DataSource;
    textboxActionDate: Textbox;
    textboxActivityId: Textbox;
    textboxCustomerId: Textbox;
    textboxCustomerconfidenceLevel: Textbox;
    textboxCustomerpotential: Textbox;
    textboxDateDue: Textbox;
    textboxDescr: Textbox;
    textboxEmail: Textbox;
    textboxInfoPacket: Textbox;
    textboxNextActDate: Textbox;
    textboxNextActId: Textbox;
    textboxNextAction: Textbox;
    textboxObjection1Script: Textbox;
    textboxObjection2Script: Textbox;
    textboxObjectionId1: Textbox;
    textboxObjectionId2: Textbox;
    textboxOperationsUser: Textbox;
    textboxOpportunityId: Textbox;
    textboxPhone: Textbox;
    textboxPrimaryContact: Textbox;
    textboxPriority: Textbox;
    textboxRemarks: Textbox;
    textboxSalespersonId: Textbox;
    textboxStatus: Textbox;
}
